module.exports = __webpack_public_path__ + "img/name88.8ea2239c.jpg";